<template>
  <div class="blocnote-container">
    <div class="blocnote-area-new">
      <button v-on:click="printNotes()" class="float-right icon-btn"><font-awesome-icon title="Imprimer" icon="print" /></button>

      <p class="text-center">Navigue dans les mises en situation et ajoute des marques-pages dans ton bloc-notes. Tu pourras y ajouter tes notes.</p>

      <div class="note-wrapper" v-for="note in allNotes" :key="note.situation + '-' + note.id" role="region" :aria-label="`note ${getTitleNote(note)}`">
        <p class="date-note">{{ convertToTextDate(note.date) }}</p>

        <div class="media">
          <img class="note-thumbnail" :src="getImgUrl(note.situation, note.id)" alt="" />
          <div class="media-body">
            <h2>
              <a :href="getNoteUrl(note.situation, note.id)">{{ getTitleNote(note) }}</a>
            </h2>

            <div class="d-flex" v-if="note.currentlyEditing">
              <div class="flex1">
                <quill-editor :ref="`textarea${note.situation}-${note.id}`" :content="note.text" :options="editorOption" />
              </div>
              <div class="ml-3">
                <button v-on:click="saveEditedNote(note.situation, note.id)" class="icon-btn"><font-awesome-icon title="Sauvegarder la note" icon="save" /></button>
                <br aria-hidden="true" />
                <button v-on:click="cancelEditingNote(note.situation, note.id)" class="icon-btn"><font-awesome-icon title="Ignorer les changements à la note" icon="undo" /></button>
              </div>
            </div>

            <div class="d-flex" v-if="!note.currentlyEditing">
              <div class="text-zone" v-html="note.text" role="region" aria-label="Note prise"></div>
              <div class="ml-3">
                <button v-on:click="askBeforRemoveNote(note.situation, note.id)" class="icon-btn"><font-awesome-icon icon="trash-alt" title="Supprimer la note" /></button> <br aria-hidden="true" />
                <button v-on:click="editNote(note.situation, note.id)" class="icon-btn"><font-awesome-icon title="Modifier la note" icon="edit" /></button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal ref="modal-confirm-suppression" id="modal-confirm-suppression" title="Supprimer la note définitivement?" hide-header centered>
        <p class="text-content">Supprimer la note définitivement?</p>
        <template slot="modal-footer">
          <b-button v-on:click="hideModal">Annuler</b-button>
          <b-button v-on:click="deleteBtnFunction">Supprimer</b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import ProgressBars from "../components/ProgressBars.vue";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  name: "Blocnote",

  components: {
    ProgressBars,
    quillEditor,
  },

  props: {
    situationIndex: { type: Number },
    noteId: { type: Number },
  },

  data() {
    return {
      deleteBtnFunction: function() {},
      allNotes: [],
      editorOption: {
        modules: {
          toolbar: [
            //
            ["bold", "underline", "italic", { script: "sub" }, { script: "super" }, { list: "ordered" }, { list: "bullet" }, "link", "clean"],
          ],
          keyboard: {
            bindings: {
              // desactivate tab key
              tab: {
                key: 9,
                handler: function() {
                  return true;
                },
              },
            },
          },
        },

        formats: ["bold", "underline", "italic", "script", "list", "link"],
      },
    };
  },

  computed: {},

  created() {},

  mounted() {
    this.allNotes = this.getAllNote();
    this.orderNoteByDate();

    if (this.hasProps()) {
      if (!this.addNote(this.situationIndex, this.noteId)) {
        this.editNote(this.situationIndex, this.noteId);
        this.getNote(this.situationIndex, this.noteId).date = new Date();
      }

      this.setNoteAtTop(this.getNote(this.situationIndex, this.noteId));
    }
  },
  beforeDestroy() {
    this.allNotes.forEach((elem) => {
      if (elem.currentlyEditing == true) {
        // this.cancelEditingNote(elem.situation, elem.id, true);
        this.saveEditedNote(elem.situation, elem.id);
      }
    });
  },

  methods: {
    setNoteAtTop(note) {
      let i = this.allNotes.map((x) => x.situation == note.situation && x.id == note.id).indexOf(true);
      this.allNotes.splice(i, 1);
      this.allNotes.unshift(note);
    },
    hasProps() {
      return this.situationIndex != undefined && this.noteId != undefined;
    },

    getNoteUrl(situationIndex, id) {
      let areaIndex = this.getMatchedIndexArea(situationIndex);
      let areaName = this.getAreaNameFromAreaIndex(areaIndex);
      let situationName = this.getSituationNameFromSituationIndex(situationIndex);

      if (id == 0) {
        return `/${areaName}/${situationName}/video`;
      } else {
        let i = id - 1;
        return `/${areaName}/${situationName}/jouer?indice=${i}`;
      }
    },

    getImgUrl(situationIndex, id) {
      let situationNumber = parseInt(situationIndex) + 1;
      let spacer = situationIndex == 0 ? "_" : "";

      if (id == 0) {
        return require(`@/assets/scenes/scene${situationNumber}/MES${situationNumber}${spacer}VideoThumbnail.png`);
      } else {
        return require(`@/assets/scenes/scene${situationNumber}/MES${situationNumber}${spacer}Indice${id}.png`);
      }
    },

    convertToTextDate(noteDate) {
      const monthNames = ["janvier", "février", "mars", "avril", "may", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
      return `${noteDate.getDate()} ${monthNames[noteDate.getMonth()]} ${noteDate.getFullYear()}`;
    },

    getTitleNote(note) {
      return this.LG(`QI_S${note.situation + 1}_Name`) + " - " + this.LG(`PP_S${note.situation + 1}_altObject${note.id}`);
    },

    getAllNote() {
      return this.$store.state.gamestate.blocNote;
    },

    addNote(situationId, noteElemId) {
      let newNote = {
        currentlyEditing: true,
        situation: situationId,
        id: noteElemId, // 0=video, 1=indice1, 2=indice2, 3=indice3, 4=indice4, 5=indice5
        text: "",
        date: new Date(),
      };

      // if note already existe do nothing
      if (this.getNote(newNote.situation, newNote.id)) {
        return false;
      }

      this.$store.commit("addToBlocNote", newNote);

      this.saveGameState();

      return true;
    },

    askBeforRemoveNote(situation, id, withoutWarning = false) {
      if (withoutWarning) {
        this.removeNote(situation, id);
      } else {
        this.showModal(situation, id);
      }
    },
    removeNote(situation, id) {
      this.$store.commit("removeElemBlocNote", { situation: situation, id: id });
      this.saveGameState();
    },

    editNote(situation, id) {
      this.getNote(situation, id).currentlyEditing = true;

      setTimeout(() => {
        this.$refs[`textarea${situation}-${id}`][0].quill.focus();
      });
    },

    cancelEditingNote(situation, id, withoutWarning = false) {
      let note = this.getNote(situation, id);
      note.currentlyEditing = false;
      if (note.text == "") {
        if (withoutWarning) {
          this.removeNote(situation, id);
        } else {
          this.askBeforRemoveNote(situation, id);
        }
      }
    },

    saveEditedNote(situation, id) {
      let text = this.$refs[`textarea${situation}-${id}`][0].quill.root.innerHTML;

      let editedNote = {
        situation: situation,
        id: id,
        text: text,
        date: new Date(),
      };

      this.$store.commit("editElemBlocNote", editedNote);

      this.saveGameState();

      this.getNote(situation, id).currentlyEditing = false;
    },

    orderNoteByDate() {
      this.allNotes.sort(function(a, b) {
        return b.date - a.date;
      });
    },

    printNotes() {
      window.print();
    },

    getNote(situationId, noteId) {
      return this.allNotes.find((x) => x.situation == situationId && x.id == noteId);
    },

    closeTab() {
      window.close();
    },

    hideModal() {
      this.$refs["modal-confirm-suppression"].hide();
    },
    showModal(situation, id) {
      this.$refs["modal-confirm-suppression"].show();
      this.deleteBtnFunction = () => {
        this.removeNote(situation, id);
        this.hideModal();
      };
    },
  },
};
</script>

<style scoped>
#modal-confirm-suppression .text-content {
  text-align: center;
  font-size: 1.3rem !important;
  font-weight: 600;
  margin-top: 15px;
  margin-bottom: 0px;
}
#modal-confirm-suppression .modal-footer {
  border: none;
}
@media (max-width: 830px) {
  .media {
    display: block;
    text-align: center;
  }
  .date-note {
    text-align: center;
  }
}

.icon-btn {
  border: none;
  background-color: transparent;
}
.icon-btn {
  font-size: 1.3rem;
}
a {
  text-decoration: underline !important;
  color: black !important;
}
.flex1 {
  flex: 1;
}
.title {
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
}
.nav.nav-tabs {
  margin-left: 50px;
}
.blocnote-container {
  margin-left: auto;
  margin-right: auto;

  /* position: fixed;
  max-width: 1100px;
  top: 60px;
  bottom: 0;
  left: 0;
  right: 0; */
}

/* .blocnote-area-new {
  border-radius: 57px;
  border: 10px solid #ffffff;
  background-color: #eaeaea;
  font-family: "Poppins";
  font-size: 17px;
  color: black;
  padding: 25px;
  min-height: 640px;
} */
.back-btn,
h1 {
  margin-bottom: 20px;
}

@media (min-width: 600px) {
  .back-btn {
    float: left;
  }
}
.note-wrapper {
  clear: both;
  margin: 10px;
  padding: 10px;
}
.quill-editor {
  background-color: white;
}
.text-zone {
  flex: 1;
  padding: 10px 10px 0 10px;
  margin-bottom: 10px;
  background-color: white;
}
.note-thumbnail {
  width: 160px;
  height: 125px;
  object-fit: scale-down;
  margin-right: 20px;
  object-position: top;
}

@media print {
  .media {
    display: flex !important;
    text-align: left !important;
  }
  .date-note {
    text-align: left !important;
  }
  button,
  nav,
  br {
    display: none !important;
  }
  /* ::v-deep .ql-toolbar.ql-snow {
    display: none !important;
  }
  ::v-deep .ql-container.ql-snow {
    border-top: 1px solid #ccc !important;
    border: none !important;
  } */
  a {
    color: black !important;
  }
}
</style>
